import React from 'react';
import { FiltersTypes } from '@monorepo/common';
import { useFilter } from '@monorepo/helpers';
import { FILTER_PARAMS } from '@monorepo/dictionary';
import useGetTypes from '../../hooks/filters/useGetTypes';

type TProps = {
  config: {
    isShowAll: boolean;
    defaultType: string | undefined;
  };
};

const TypesFilter: FC<TProps> = ({ config }) => {
  const { isShowAll = false, defaultType } = config;
  const { filter } = useFilter();
  const { data, isFetching } = useGetTypes({
    grouping: null,
    filter,
    active: FILTER_PARAMS.typeId
  });

  if (!isFetching && !data) {
    return null;
  }

  return (
    <FiltersTypes data={data} defaultType={defaultType} isShowAll={isShowAll} />
  );
};

export default TypesFilter;
